import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router'

import { QuotesEvent, trackQuotesEvent } from './quotesAnalytics'

/** Matches the backend's STAFF_LINK_REDIRECT_PATH (`/quotes?from=staff_link`). */
const STAFF_LINK_SOURCE = 'staff_link'

/** Reports a staff-sent sign-in link landing here once, then drops the marker from the URL. */
export function useStaffLinkOpenedEvent() {
  const [searchParams, setSearchParams] = useSearchParams()
  const reported = useRef(false)
  const fromStaffLink = searchParams.get('from') === STAFF_LINK_SOURCE

  useEffect(() => {
    if (!fromStaffLink || reported.current) return
    reported.current = true
    trackQuotesEvent(QuotesEvent.CUSTOMER_LINK_OPENED)
    setSearchParams(
      (params) => {
        params.delete('from')
        return params
      },
      { replace: true }
    )
  }, [fromStaffLink, setSearchParams])
}
